// we can delete that when we have a table for VIP Portal Privileges and the tool to set privileges for roles

const PrivilegeNames = {
  ReportBase: 'report-base',
  WelcomePage: 'welcome-page',
  NotificationList: 'notification-list',
  UnitSearch: 'unit-search',
  UnitSelection: 'unit-selection',
  IndustryReports: 'industry-reports',
  BaseLine: 'baseline',
  Customization: 'customization',
  AppraisalView: 'appraisal-view',
  StrengthsAndChallenges: 'strengths-and-challenges',
  AppraisalComparison: 'appraisal-comparison',
  OrganizationSearch_Advanced: 'organization-search-advanced',
  OrganizationSearch_Standard: 'organization-search-standard',
  OrganizationReports: 'organization-reports',
  AggregateAppraisalReport: 'aggregate-appraisal-report',
  DeltaPerformanceReport: 'delta-performance-report',
  DetailedAppraisalReport: 'detailed-appraisal-report',
  ActualPerformanceReport: 'actual-performance-report',
  OrganizationReports_UnitReports: 'organization-reports-unit-reports',
  OrganizationReports_ExecutiveSummary: 'organization-reports-executive-summary',
  OrganizationReports_ExecutiveSummary_EditCommentary:
    'organization-reports-executive-summary-edit-commentary',
  OrganizationReports_ExecutiveSummary_OrgStrengthsAndChallenges:
    'organization-reports-executive-summary-org-strengths-and-challenges',
  OrganizationReports_ExecutiveSummary_Download: 'organization-reports-executive-summary-download',
  Resources: 'resources',
  Resources_Edit: 'resources-edit',
  UserManagement: 'user-management',
  UserManagement_LicenseChange_AppraiserAtm: 'user-management-license-change-appraiser-atm',

  UserManagement_ChangeLicense_DeactivatedLicenses:
    'user-management-change-license-deactivated-licenses',
  UserManagement_ChangeLicense_MoveToOrg: 'user-management-change-license-move-to-org',
  UserManagement_ChangeLicense_ChangeUserFreeStatus:
    'user-management-change-license-change-user-free-status',
  UserManagement_ChangeLicense_MoveLicenseIsacaOrgUnitToIsacaOrgUnit:
    'user-management-change-license-move-license-isaca-org-unit-to-isaca-org-unit',

  UserManagement_SetAccessInvoices: 'user-management-set-access-invoices',
  UserManagement_CanEditSuperUser: 'user-management-can-edit-super-user',
  UserManagement_CertificationPathwayProgress: 'user-management-certification-pathway-progress',
  ReportManagement: 'report-management',
  ReleaseNotes: 'release-notes',
  CheckPoints: 'check-points',
  CheckPoints_UploadRequiredFiles: 'check-points-upload-required-files',
  CheckPoints_SaveDraft: 'check-points-save-draft',
  CheckPoints_ReappraisalRationaleReview: 'check-points-reappraisal-rationale-review',
  CheckPoints_Edit_NonEditableFields: 'checkpoint-edit-non-editable-fields',
  ReappraisalRationaleReview: 'reappraisal-rationale-review',
  LicenseManagement: 'license-management',
  SubmitFeedback: 'submit-feedback',
  ViewFeedback: 'view-feedback',
  DataDownloadPage: 'data-download-page',
  Calendar: 'calendar',
  Calendar_EventType_Regular: 'calendar-event-type-regular',
  Calendar_ATMToggle: 'calendar-atm-toggle',
  Calendar_ViewEvents_UserAvailability: 'calendar-view-events-user-availability',
  Calendar_ViewEvents_UnitAvailability: 'calendar-view-events-unit-availability',
  Calendar_ViewEvents_AtmUsers: 'calendar-view-events-atm-users',
  Calendar_AddEvent: 'calendar-add-event',
  Calendar_DeleteEvent: 'calendar-delete-event',
  Calendar_EditEvent: 'calendar-edit-event',
  Calendar_EditEvent_ChangeDateRequest: 'calendar-edit-event-change-date-request',
  Calendar_EditEvent_ChangeDateRequest_Review: 'calendar-edit-event-change-date-request-review',
  Calendar_EditEvent_EditExtraFields: 'calendar-edit-event-edit-extra-fields',
  Calendar_EditEvent_EditOrgUnits: 'calendar-edit-event-edit-org-units',
  Calendar_EditEvent_EditTravelInformation: 'calendar-edit-event-edit-travel-information',
  Calendar_EditEvent_EditTravelInformation_Atl_Submitted_Subsequent_Stages:
    'calendar-edit-event-edit-travel-information-atl-submitted-subsequent-stages',
  Calendar_EditEvent_EditTeams: 'calendar-edit-event-edit-teams',
  Calendar_EditEvent_EditTeams_Atl_Submitted_Subsequent_Stages:
    'calendar-edit-event-edit-teams-atl-submitted-subsequent-stages',
  Calendar_EditEvent_EditIntendedDates: 'calendar-edit-event-edit-intended-dates',
  Calendar_EditEvent_EditAtlPreferences: 'calendar-edit-event-edit-atl-preferences',
  Calendar_EditEvent_ViewAtlPreferences: 'calendar-edit-event-view-atl-preferences',
  Calendar_EditEvent_BidOnEvent: 'calendar-edit-event-bid-on-event',
  Calendar_EditEvent_SaveEvent: 'calendar-edit-event-save-event',
  Calendar_EditEvent_DraftStage: 'calendar-edit-event-draft-stage',
  Calendar_EditEvent_AtlAssignedStage: 'calendar-edit-event-atl-assigned-stage',
  Calendar_EditEvent_TeamAssignment: 'calendar-edit-event-team-assignment',
  Calendar_EditEvent_EditDeliveryMethod: 'calendar-edit-event-edit-delivery-method',
  Calendar_EditEvent_EditDeliveryMethod_Submitted_Subsequent_Stages:
    'calendar-edit-event-edit-delivery-method-submitted_subsequent_stages',
  Calendar_EditEvent_ATMAssignment: 'calendar-edit-event-atm-assignment',
  Calendar_EditEvent_ATMAssignment_OpenForBid_Subsequent_Stages:
    'calendar-edit-event-atm-assignment-open-for-bid-subsequent-stages',
  Calendar_EditEvent_ATMObservationSection: 'calendar-edit-event-atm-observation-section',
  Calendar_EditEvent_FinalizeEvent: 'calendar-edit-event-finalize-event',
  Calendar_EditEvent_SowTable: 'calendar-edit-event-sow-table',
  Calendar_EditEvent_ReadyEvent: 'calendar-edit-event-ready-event',
  Calendar_EditEvent_Observation_ATL: 'calendar-edit-event-observation-atl',
  Calendar_SubmitEvent: 'calendar-submit-event',
  Calendar_SubmitEventReview: 'calendar-submit-event-review',
  Calendar_EditEvent_EditRescheduleWarning: 'calendar-edit-event-edit-reschedule-warning',
  Calendar_AccessPastEvents: 'calendar-access-past-events',
  Calendar_ChangeDateRequestReview: 'calendar-change-date-request-review',
  Calendar_ATLBidOnEvent: 'calendar-atl-bid-on-event',

  Calendar_AddEvent_DirectChannel: 'calendar-add-event-direct-channel',
  Calendar_EventType_DirectChannel: 'calendar-event-type-direct-channel',
  Calendar_EditEvent_EditDates_DirectChannel: 'calendar-edit-event-edit-dates-direct-channel',
  Calendar_EditEvent_ChangeDateRequest_DirectChannel:
    'calendar-edit-event-change-date-request-direct-channel',
  Calendar_EditEvent_EditDeliveryMethod_DirectChannel:
    'calendar-edit-event-edit-delivery-method-direct-channel',
  Calendar_EditEvent_EditDeliveryMethod_Submitted_Subsequent_Stages_DirectChannel:
    'calendar-edit-event-edit-delivery-method-submitted_subsequent_stages-direct-channel',

  AppraiserProfile: 'appraiser-profile',
  AppraiserProfile_AtlAssignment: 'appraiser-profile-atl-assignment',
  AppraiserProfile_DirectChannel_Edit: 'appraiser-profile-direct-channel-edit',
  AppraiserProfile_Observation_Edit: 'appraiser-profile-observation-edit',
  AppraiserProfile_AdditionalInformation_Edit: 'appraiser-profile-additional-information-edit',
  EmailPreferences: 'email-preferences',
  NotificationCenter: 'notification-center',
  Invoices: 'invoices',
  LegalDocuments: 'legal-documents',
  LegalDocuments_Add: 'legal-documents-add',
  LegalDocuments_Delete: 'legal-documents-delete',
  LegalDocuments_AccessDocuments: 'legal-documents-access-documents',
  AggregatePerformanceReport: 'aggregate-performance-report',
  AggregatePerformanceReport_Download: 'aggregate-performance-report-download',
  DataCorrelations: 'data-correlations',
  PostAppraisalSurvey: 'post-appraisal-survey',
  PostAppraisalSurvey_Edit: 'post-appraisal-survey-edit',
  PostAppraisalSurvey_Download: 'post-appraisal-survey-download',
  TasksDueNotification: 'tasks-due-notification',
  TasksDueNotification_ObservationReport: 'tasks-due-notification-observation-report',
  ObservationReport: 'observation-report',
  ObservationReport_Review: 'observation-report-review'
};

export default PrivilegeNames;
